import { modifier } from 'ember-modifier'
import qrcode from 'qrcode-generator'

interface Signature {
  Args: {
    Named: {
      encode: string
    }
    Positional: unknown[]
  }
  Element: HTMLImageElement
}

export default modifier<Signature>(function qrCode(element, _positional, named) {
  const qr = qrcode(0, 'L')
  qr.addData(named.encode)
  qr.make()
  const frameSize = Math.min(element.offsetWidth, element.offsetHeight)
  const moduleCount = qr.getModuleCount() // number of individual squares across
  const cellSize = Math.floor(frameSize / moduleCount)
  const margin = 0
  element.setAttribute('src', qr.createDataURL(cellSize, margin))
})
